import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Chip, ChipPropsVariantOverrides, IconButton, TableCell, TableRow } from '@mui/material'
import React from 'react'
import { formatPercent } from '../../../services/CommonServices/DataFormatters'
import { WorkItem } from '../../../types/Work/WorkItem'
import AnimatedNumberField from '../../core/AnimatedNumberField'
import { OpenAttachmentsButton } from '../../attachments/OpenAttachmentsButton'
import { OpenInfoDialogButton } from '../../workiteminfo/OpenInfoDialogButton'
import { QCTaskRow } from './QCTaskRow'

type QCWorkItemRowProps = {
	workItem: WorkItem
	selectAttachments: (workItemId: number) => void
	layer: number
}

export function QCWorkItemRow({ workItem, selectAttachments, layer }: QCWorkItemRowProps) {
	const [open, setOpen] = React.useState(true)

	const getLayerVariant = (): keyof ChipPropsVariantOverrides => {
		return `Layer${workItem.wbsIndex}${
			workItem.outOfScope ? 'OutOfScope' : 'WorkItem'
		}` as keyof ChipPropsVariantOverrides
	}
	return (
		<>
			<TableRow key={workItem.id} sx={{ backgroundColor: 'white' }}>
				<TableCell>
					{((workItem?.tasks?.length ?? 0) > 0 || workItem.childrenWorkItems) && (
						<IconButton
							aria-label='expand row'
							sx={{ pl: layer - 1 }}
							size='small'
							onClick={() => setOpen(!open)}
						>
							{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
						</IconButton>
					)}
				</TableCell>
				<TableCell align='center'>
					<Chip label={workItem.typeName} variant={getLayerVariant()} />
				</TableCell>
				<TableCell align='center'>
					{workItem.outOfScope ? workItem.wbsName : workItem.craftName}
				</TableCell>

				<TableCell align='left'>{workItem.name}</TableCell>
				<TableCell align='left'>
					{workItem.outOfScope ? <></> : <OpenInfoDialogButton workItem={workItem} />}
				</TableCell>
				<TableCell />

				<TableCell align='center'>
					<OpenAttachmentsButton
						selectAttachments={() => selectAttachments(workItem.id)}
						attachmentCount={workItem.attachmentCount}
					/>
				</TableCell>
				<TableCell />
				<TableCell />

				<TableCell align='center'>{workItem.quantityBudgeted}</TableCell>
				<TableCell align='center'></TableCell>
				<TableCell align='center'>{workItem.unitOfMeasure}</TableCell>
				<TableCell align='center'>
					<AnimatedNumberField value={workItem.quantityEarned} />
				</TableCell>
				<TableCell align='center'>
					<AnimatedNumberField value={workItem.quantityRemaining} />
				</TableCell>
				<TableCell align='center'>
					<AnimatedNumberField value={formatPercent(workItem.percentComplete)} />
				</TableCell>
				<TableCell />
				<TableCell align='center'>{workItem.budgetedHours}</TableCell>
				<TableCell align='center'>
					<AnimatedNumberField value={workItem.earnedHours} />
				</TableCell>
				<TableCell align='center'>
					<AnimatedNumberField value={workItem.burnedHours} />
				</TableCell>
				<TableCell align='center'>
					<AnimatedNumberField value={workItem.pf} />
				</TableCell>
			</TableRow>
			{workItem.childrenWorkItems &&
				open &&
				workItem.childrenWorkItems.map((child, index) => (
					<QCWorkItemRow
						layer={layer + 1}
						workItem={child}
						key={index}
						selectAttachments={selectAttachments}
					/>
				))}
			{open && (workItem.tasks ?? []).map((t) => <QCTaskRow task={t} key={t.id} />)}
		</>
	)
}
